<div class="container features-grid">
    @for (feature of features; track feature.title; let i = $index) {
    <div
        class="feature-card"
        data-reveal
        [style.--d]="(i * 0.06) + 's'"
        [class.expandable]="isExpandable(i)"
        [class.expanded]="expanded[i]"
        [attr.tabindex]="isExpandable(i) ? 0 : null"
        [attr.role]="isExpandable(i) ? 'button' : null"
        [attr.aria-expanded]="isExpandable(i) ? expanded[i] : null"
        (click)="toggleExpanded(i)"
        (keydown.enter)="toggleExpanded(i)"
        (keydown.space)="toggleExpanded(i); $event.preventDefault()">
        <div class="feature-icon">
            <i class="bi {{feature.icon}}"></i>
        </div>
        <div class="feature-card-heading">
            <h3>{{feature.title}}</h3>
            @if (isExpandable(i)) {
                <i class="bi bi-chevron-down feature-toggle-icon" aria-hidden="true"></i>
            }
        </div>
        <p class="feature-excerpt">{{feature.details[0]}}</p>
        @if (isExpandable(i)) {
            <p class="feature-detail">{{ extraDetails(i) }}</p>
        }
    </div>
    }
</div>
